module.exports = __webpack_public_path__ + "DINNextLTPro-Black.woff?cdf4c1f861e58739edcddae7632df52a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Black.woff
// module id = 1440
// module chunks = 0